import { useSyncExternalStore } from "react";

/** Kapsam seçici (Prompt 04): tüm istasyonlar / bölge / tek istasyon. Raporlar ve panolar bu seçime göre süzülür. */
export type Scope =
  { kind: "all" } | { kind: "region"; regionId: string } | { kind: "station"; stationId: string };

const listeners = new Set<() => void>();
const storageKey = (tenantId: string) => `station.scope.${tenantId}`;
let current: { tenantId: string | null; scope: Scope } = { tenantId: null, scope: { kind: "all" } };

/** Kiracı değişince o kiracı için en son seçilen kapsam yüklenir. */
export function loadScope(tenantId: string | null): void {
  if (current.tenantId === tenantId) return;
  let scope: Scope = { kind: "all" };
  try {
    if (tenantId)
      scope = (JSON.parse(localStorage.getItem(storageKey(tenantId)) ?? "null") as Scope | null) ?? scope;
  } catch {
    // bozuk kayıt: varsayılana dön
  }
  current = { tenantId, scope };
  listeners.forEach((listener) => listener());
}

export function setScope(scope: Scope): void {
  current = { ...current, scope };
  if (current.tenantId) localStorage.setItem(storageKey(current.tenantId), JSON.stringify(scope));
  listeners.forEach((listener) => listener());
}

export function useScope(): Scope {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current.scope,
  );
}
